<template>
    <ul class="navbar-nav float-lg-right mai-icons-nav" v-if="hasItems">
        <li v-if="$store.state.user.permissions.user_manage_everybody" class="nav-item">
            <a href="#" @click.prevent="resetContext" class="nav-link">{{ $t('topmenu.search') }}</a>
        </li>
        <li v-if="$store.state.user.permissions.user_manage_everybody && noContext" class="nav-item">
            <router-link :to="{name: 'requisitions'}" class="nav-link hidden-sm-down">{{ $t('topmenu.requisitions') }}</router-link>
        </li>
        <li class="nav-item" v-if="showCustomerUnits">
            <router-link :to="{name: 'sensors.table'}" class="nav-link hidden-sm-down">{{ $t('topmenu.customer_units') }}</router-link>
        </li>
        <li class="nav-item" v-if="showCustomerFirmwareUpdate">
            <router-link :to="{name: 'sensors.firmware.updates'}" class="nav-link hidden-sm-down">{{ $t('topmenu.firmware_update') }}</router-link>
        </li>
        <li class="nav-item" v-if="showMyUnits">
            <router-link :to="{name: 'sensors.table'}" class="nav-link hidden-sm-down">{{ $t('topmenu.my_units') }}</router-link>
        </li>
        <li class="nav-item" v-if="showCustomerActivity">
            <router-link :to="{name: 'activity'}" class="nav-link hidden-sm-down">{{ $t('topmenu.activity') }}</router-link>
        </li>
        <li v-if="$store.state.user.permissions.api_manage && noContext" class="nav-item">
            <router-link :to="{name: 'firmware'}" class="nav-link hidden-sm-down">{{ $t('topmenu.firmware') }}</router-link>
        </li>
        <li v-if="$store.state.user.permissions.api_manage && noContext" class="nav-item">
            <router-link :to="{name: 'api'}" class="nav-link hidden-sm-down">{{ $t('topmenu.api') }}</router-link>
        </li>
        <li v-if="$store.state.user.permissions.api_manage && noContext" class="nav-item">
            <router-link :to="{name: 'expired'}" class="nav-link hidden-sm-down">Udl&oslash;bet</router-link>
        </li>
    </ul>
</template>

<script>
    import {canAccess} from "../../../router/functions"

    export default {
        computed: {
            showCustomerUnits(){
                return canAccess(['user_manage_everybody','context_exists'])
            },
            showMyUnits(){
                return canAccess(['user_manage_others']) && this.noContext
            },
            showCustomerActivity(){
                return canAccess(['activity_view','context_exists'])
            },
            showCustomerFirmwareUpdate(){
                return canAccess(['user_manage_everybody','context_exists'])
            },
            noContext(){
                return this.$store.getters.getTargetContext.id === this.$store.getters.getUser.id;
            },
            hasItems(){
                return (this.$store.state.user.permissions.user_manage_everybody  && this.noContext
                || this.showCustomerUnits
                || this.showMyUnits
                || this.showCustomerActivity
                || this.showCustomerFirmwareUpdate
                || this.$store.state.user.permissions.api_manage && this.noContext);
            }
        },
        methods: {
            resetContext(){
                this.$store.commit("clearContext");
                this.$router.push({name: "dashboard"});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/topbar/topmenu.vue